type FunctionToHandle<T> = (...args: any[]) => Promise<T>;

export default async function useErrorHandling<T> (fn: FunctionToHandle<T>, errorMessage?: string): Promise<T | undefined> {
  try {
    const result = await fn();
    return result;
  } catch (_error) {
    const error = _error as {
      statusCode?: number;
      statusMessage?: string;
      message?: string;
      cause?: string;
      data?: { message?: string };
      response?: any;
    };

    const { $sentry } = useNuxtApp();
    const { dispatchMessage } = useSystemMessages();

    if (!error) {
      $sentry?.captureException(new Error('Unknown error caught in useErrorHandling'));
      dispatchMessage('Error', 'error', 'An error occurred.');
      return;
    }

    let statusMessage = 'Internal Server Error';

    if (error.statusMessage) {
      statusMessage = error.statusMessage;
    }

    if (!error.statusMessage && !error.response) {
      statusMessage = 'Response is empty, please check your network connection.';
    }

    const summary = errorMessage || 'Error';
    const detail = error.data?.message || error.cause || error.message || statusMessage;
    $sentry?.captureException(error);

    dispatchMessage(summary, 'error', detail);
  }
}
